import React from 'react';

/**
 * @param {object} props
 * @return {*}
 * @constructor
 */
const CardBody = (props) => (
    <div className={`${!props.tight ? 'p-4' : ''} bg-white ${props.className}`}>
        {props.children}
    </div>
);

export default CardBody;
